import { createFileRoute, redirect } from '@tanstack/react-router';
import { Box, CircularProgress } from '@mui/material';
import { MainLayout } from '../components/layout/MainLayout';
import { store } from '../app/store';
import { logout, sessionRefreshed } from '../features/auth/slice';
import { isTokenValid } from '../services/tokenService.ts';
import { refreshOAuthTokens } from '../services/tokenService.ts';

export const Route = createFileRoute('/_protected')({
  beforeLoad: async ({ location }) => {
    const state = store.getState();
    const isAuthenticated = state.auth.isAuthenticated;

    // Validate token. If expired, try refresh before forcing logout.
    if (isAuthenticated && !isTokenValid()) {
      try {
        const tokenResponse = await refreshOAuthTokens();
        store.dispatch(
          sessionRefreshed({
            accessToken: tokenResponse.access_token,
            homePageUrl: tokenResponse.home_page_url,
            logoPageUrl: tokenResponse.logo_page_url,
          })
        );
      } catch {
        store.dispatch(logout());
        throw redirect({
          to: '/login',
          search: {
            redirect: location.href,
          },
        });
      }
    }

    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  pendingComponent: LoadingComponent,
  component: LayoutComponent,
});

function LoadingComponent() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
}

function LayoutComponent() {
  return <MainLayout />;
}
